<template>
  <ProductPricePage
    :product="data.product"
    :product-data="data.productData"
    :subscription="subscription"
  >
    <NuxtPage
      :product="data.product"
      :product-data="data.productData"
      :subscription="subscription"
    />
  </ProductPricePage>
</template>

<script setup lang="ts">
import {
  NICKEL,
  MARKET,
  SUBSCRIPTION_PRICE_ASSESSMENTS_NICKEL,
} from '~/constants/services/constants'
import nickelData from '~/constants/price-assessments/unauthorized/nickel'
import ProductPricePage from '~/components/market/ProductPricePage.vue'

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ layout: 'services' })

const subscription = SUBSCRIPTION_PRICE_ASSESSMENTS_NICKEL
const data = {
  product: NICKEL,
  productData: nickelData,
  subscription,
}

/*-------------------------------------
  SEO
-------------------------------------*/
const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${NICKEL.name} Prices`,
})
useHead(seo)
</script>
